import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-upload-documents-dialog',
  templateUrl: './upload-documents-dialog.component.html',
  styleUrls: ['./upload-documents-dialog.component.scss']
})
export class UploadDocumentsDialogComponent {
  srcImg: string;
  public titleText = '';
  assetsUrl = environment.assetsUrl;
  constructor(
    public dialogRef: MatDialogRef<UploadDocumentsDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      attachId: boolean;
      attachWorkDocuments: boolean;
      attachIndependentDocuments: boolean;
    }
  ) {
    this.srcImg =
      this.data.attachId &&
      !this.data.attachWorkDocuments &&
      !this.data.attachIndependentDocuments
        ? this.assetsUrl +
          '/images/cdt/illustrations/upload-documents/cedula-pop-up.svg'
        : this.assetsUrl +
          '/images/cdt/illustrations/upload-documents/documento-y-cedula-pop-up.svg';
    this.setTitle();
  }

  setTitle() {
    if (
      this.data.attachId &&
      !this.data.attachWorkDocuments &&
      !this.data.attachIndependentDocuments
    ) {
      this.titleText =
        'Coloca tu cédula en posición horizontal sobre un fondo blanco, apaga el flash y toma la foto con tu celular.';
    } else if (
      this.data.attachId &&
      (this.data.attachWorkDocuments || this.data.attachIndependentDocuments)
    ) {
      this.titleText =
        'Coloca el documento en posición vertical y la cédula en posición horizontal sobre un fondo blanco, apaga el flash y toma la foto con tu celular (una por cada documento).';
    } else if (
      !this.data.attachId &&
      (this.data.attachWorkDocuments || this.data.attachIndependentDocuments)
    ) {
      this.titleText =
        'Coloca el documento en posición vertical sobre un fondo blanco, apaga el flash y toma la foto con tu celular.';
    }
  }
}
